export const safeAreaInsetTop = 'env(safe-area-inset-top, 0)';
export const safeAreaInsetBottom = 'env(safe-area-inset-bottom, 0)';

// This sits above iPhoneX (375px) and below the next breakpoint smUp (576px)
export const MEDIA_QUERY_376 = '@media (min-width: 376px)';
